import React, { useEffect } from "react";
import ViewAllBrand from "../../components/view-all-brand/ViewAllBrand";

function ViewAllBrandPage({setShow}) {
 
  return <><ViewAllBrand /></>;
}

export default ViewAllBrandPage;
